import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classnames from 'classnames';
import Linker from '../../base/Linker';
import Icon from '../../base/Icon';
import Avatar from '../../base/Avatar';
import toasty from '@/components/base/Toast';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
export default function AddressText(props) {
    var address = props.address, _showAvatar = props.showAvatar, showAvatar = _showAvatar === void 0 ? true : _showAvatar, _copyable = props.copyable, copyable = _copyable === void 0 ? true : _copyable, _onCopy = props.onCopy, onCopy = _onCopy === void 0 ? function() {
        return toasty({
            content: 'Copied'
        });
    } : _onCopy, href = props.href, _className = props.className, className = _className === void 0 ? '' : _className, _style = props.style, style = _style === void 0 ? {} : _style, rest = _objectWithoutProperties(props, [
        "address",
        "showAvatar",
        "copyable",
        "onCopy",
        "href",
        "className",
        "style"
    ]);
    if (!address) return(/*#__PURE__*/ _jsx(_Fragment, {
        children: "--"
    }));
    var ref = _slicedToArray(address.split(':'), 2), addr = ref[0], alg = ref[1];
    return(/*#__PURE__*/ _jsxs("div", {
        className: classnames([
            'flex items-center',
            className
        ]),
        style: style,
        children: [
            showAvatar && /*#__PURE__*/ _jsx("span", {
                className: "mr-[12px]",
                children: /*#__PURE__*/ _jsx(Avatar, {
                    height: 24,
                    width: 24,
                    className: "text-desc text-[24px]"
                })
            }),
            href ? /*#__PURE__*/ _jsx(Linker, _objectSpread({
                className: "font-mono",
                href: href
            }, rest, {
                children: addr
            })) : /*#__PURE__*/ _jsx("span", {
                className: "font-mono",
                children: addr
            }),
            alg && /*#__PURE__*/ _jsx("span", {
                className: "text-desc bg-[#E5E6EB] rounded-[4px] px-[6px] ml-[8px] mr-[12px] text-[14px]",
                children: alg
            }),
            copyable && /*#__PURE__*/ _jsx(CopyToClipboard, {
                text: address,
                onCopy: onCopy,
                children: /*#__PURE__*/ _jsx(Icon, {
                    type: "copy",
                    className: "cursor-pointer text-[16px]"
                })
            })
        ]
    }));
};
